<!-- apex-dashboard.component.html -->
<div class="p-6 bg-gray-100 min-h-screen">
  <div class="flex justify-between items-center mb-6 flex-wrap gap-4">
    <div>
      <h1 class="text-3xl font-bold text-gray-800">Panel de Control Financiero</h1>
      <span *ngIf="accessLevel === 'BASIC'" class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 mt-2">
        <fa-icon [icon]="['fas', 'info-circle']" class="mr-1"></fa-icon>
        Vista básica - Contacta a tu administrador para acceso completo
      </span>
    </div>
    <div class="flex items-center gap-3">
      <!-- Filtro de Mes/Año -->
      <div class="flex items-center gap-2 bg-white border border-gray-300 rounded-lg px-3 py-1.5 shadow-sm">
        <fa-icon [icon]="['fas', 'calendar-alt']" class="text-gray-500 text-sm"></fa-icon>
        <select
          [(ngModel)]="selectedMonth"
          (ngModelChange)="onFilterChange()"
          [disabled]="isLoading"
          class="bg-transparent border-none text-sm text-gray-700 font-medium focus:outline-none cursor-pointer pr-1">
          <option *ngFor="let m of months" [ngValue]="m.value">{{ m.label }}</option>
        </select>
        <select
          [(ngModel)]="selectedYear"
          (ngModelChange)="onFilterChange()"
          [disabled]="isLoading"
          class="bg-transparent border-none text-sm text-gray-700 font-medium focus:outline-none cursor-pointer">
          <option *ngFor="let y of availableYears" [ngValue]="y">{{ y }}</option>
        </select>
      </div>
      <button
        (click)="refreshDashboard()"
        [disabled]="isLoading"
        class="bg-blue-600 hover:bg-blue-700 disabled:bg-blue-400 text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 transition-colors">
        <fa-icon [icon]="['fas', 'refresh']" [ngClass]="{'animate-spin': isLoading}"></fa-icon>
        {{ isLoading ? 'Actualizando...' : 'Actualizar' }}
      </button>
    </div>
  </div>
  
  <!-- Widget de Tarea Diaria de Reportes -->
  <div *ngIf="canViewReportUpload && dailyTaskStatus" 
       class="mb-6 rounded-xl shadow-sm overflow-hidden"
       [ngClass]="dailyTaskStatus.isComplete ? 'bg-emerald-50 border border-emerald-200' : 'bg-amber-50 border border-amber-200'">
    <div class="p-4 flex items-center justify-between flex-wrap gap-4">
      <div class="flex items-center gap-4">
        <div [ngClass]="dailyTaskStatus.isComplete ? 'bg-emerald-100' : 'bg-amber-100'" 
             class="p-3 rounded-xl">
          <svg *ngIf="dailyTaskStatus.isComplete" class="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <svg *ngIf="!dailyTaskStatus.isComplete" class="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div>
          <h3 class="font-semibold" [ngClass]="dailyTaskStatus.isComplete ? 'text-emerald-800' : 'text-amber-800'">
            Tarea Diaria de Reportes
          </h3>
          <p class="text-sm" [ngClass]="dailyTaskStatus.isComplete ? 'text-emerald-600' : 'text-amber-600'">
            {{ dailyTaskStatus.isComplete ? 'Completado ✓' : 'Pendiente - Debes cargar los reportes del día' }}
          </p>
        </div>
      </div>
      <div class="flex items-center gap-4">
        <div class="flex items-center gap-3 text-sm">
          <span class="flex items-center gap-1" [ngClass]="dailyTaskStatus.wompiUploaded ? 'text-emerald-600' : 'text-gray-400'">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                    [attr.d]="dailyTaskStatus.wompiUploaded ? 'M5 13l4 4L19 7' : 'M12 8v4m0 4h.01'" />
            </svg>
            Wompi
          </span>
          <span class="flex items-center gap-1" [ngClass]="dailyTaskStatus.plinkUploaded ? 'text-emerald-600' : 'text-gray-400'">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
                    [attr.d]="dailyTaskStatus.plinkUploaded ? 'M5 13l4 4L19 7' : 'M12 8v4m0 4h.01'" />
            </svg>
            Plink
          </span>
        </div>
        <button *ngIf="!dailyTaskStatus.isComplete"
                (click)="goToReportUpload()"
                class="bg-amber-600 hover:bg-amber-700 text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
          </svg>
          Cargar Reportes
        </button>
        <button *ngIf="dailyTaskStatus.isComplete"
                (click)="goToReportUpload()"
                class="bg-emerald-600 hover:bg-emerald-700 text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 transition-colors">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
          Ver Estado
        </button>
      </div>
    </div>
  </div>

  <!-- Sin acceso al dashboard -->
  <div *ngIf="accessLevel === 'NONE' && !isLoading" class="bg-red-50 border border-red-200 rounded-lg p-6 text-center">
    <fa-icon [icon]="['fas', 'lock']" class="text-red-500 text-4xl mb-4"></fa-icon>
    <h2 class="text-xl font-semibold text-red-800 mb-2">Acceso Restringido</h2>
    <p class="text-red-600">No tienes permisos para acceder al dashboard. Contacta a tu administrador.</p>
  </div>
  
  <!-- Loading Message -->
  <div *ngIf="isLoading" class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
    <div class="flex items-center">
      <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600 mr-3"></div>
      <p class="text-blue-800 font-medium">Cargando datos en tiempo real...</p>
    </div>
  </div>

  <!-- Dashboard Content - Solo visible si tiene acceso -->
  <ng-container *ngIf="hasBasicAccess">
  
    <!-- ============================================ -->
    <!-- SECCIÓN FULL: KPIs, Gráficos y Proyectos    -->
    <!-- ============================================ -->
    <ng-container *ngIf="hasFullAccess">
      <!-- KPI Cards -->
      <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-6 gap-6 mb-8">
    <div class="bg-blue-50 border border-blue-300 rounded-2xl p-5 shadow-sm">
      <div class="flex items-center justify-between">
        <fa-icon [icon]="['fas', 'wallet']" class="text-blue-600 text-2xl"></fa-icon>
        <p class="text-sm text-blue-700 font-medium">Ingresos Totales</p>
      </div>
      <p class="text-2xl font-bold text-blue-800 mt-2">
        <span *ngIf="!isLoading">$ {{ totalIncome | number:'1.0-0' }}</span>
        <span *ngIf="isLoading" class="animate-pulse">$ --</span>
      </p>
    </div>

    <div class="bg-red-50 border border-red-300 rounded-2xl p-5 shadow-sm">
      <div class="flex items-center justify-between">
        <fa-icon [icon]="['fas', 'money-bill-wave']" class="text-red-600 text-2xl"></fa-icon>
        <p class="text-sm text-red-700 font-medium">Egresos Totales</p>
      </div>
      <p class="text-2xl font-bold text-red-800 mt-2">
        <span *ngIf="!isLoading">$ {{ totalExpenses | number:'1.0-0' }}</span>
        <span *ngIf="isLoading" class="animate-pulse">$ --</span>
      </p>
    </div>

    <div class="bg-emerald-50 border border-emerald-300 rounded-2xl p-5 shadow-sm">
      <div class="flex items-center justify-between">
        <fa-icon [icon]="['fas', 'chart-line']" class="text-emerald-600 text-2xl"></fa-icon>
        <p class="text-sm text-emerald-700 font-medium">Beneficio Neto</p>
      </div>
      <p class="text-2xl font-bold" [ngClass]="{'text-emerald-800': netProfit >= 0, 'text-red-800': netProfit < 0}">
        <span *ngIf="!isLoading">$ {{ netProfit | number:'1.0-0' }}</span>
        <span *ngIf="isLoading" class="animate-pulse">$ --</span>
      </p>
    </div>

    <div class="bg-green-50 border border-green-300 rounded-2xl p-5 shadow-sm">
      <div class="flex items-center justify-between">
        <fa-icon [icon]="['fas', 'users']" class="text-green-600 text-2xl"></fa-icon>
        <p class="text-sm text-green-700 font-medium">Participantes Activos</p>
      </div>
      <p class="text-2xl font-bold text-green-800 mt-2">
        <span *ngIf="!isLoading">{{ activeParticipants }}</span>
        <span *ngIf="isLoading" class="animate-pulse">--</span>
      </p>
    </div>

    <div class="bg-purple-50 border border-purple-300 rounded-2xl p-5 shadow-sm">
      <div class="flex items-center justify-between">
        <fa-icon [icon]="['fas', 'building']" class="text-purple-600 text-2xl"></fa-icon>
        <p class="text-sm text-purple-700 font-medium">Empresas Vinculadas</p>
      </div>
      <p class="text-2xl font-bold text-purple-800 mt-2">
        <span *ngIf="!isLoading">{{ companies }}</span>
        <span *ngIf="isLoading" class="animate-pulse">--</span>
      </p>
    </div>

    <div class="bg-orange-50 border border-orange-300 rounded-2xl p-5 shadow-sm">
      <div class="flex items-center justify-between">
        <fa-icon [icon]="['fas', 'clipboard-list']" class="text-orange-600 text-2xl"></fa-icon>
        <p class="text-sm text-orange-700 font-medium">Órdenes Pendientes</p>
      </div>
      <p class="text-2xl font-bold text-orange-800 mt-2">
        <span *ngIf="!isLoading">{{ pendingWorkOrders }}</span>
        <span *ngIf="isLoading" class="animate-pulse">--</span>
      </p>
    </div>
  </div>

  <!-- Ingresos vs Egresos Chart (Áreas apiladas) -->
  <div class="bg-white p-6 rounded-2xl shadow-md border border-gray-200 mb-8">
    <h2 class="text-xl font-semibold text-gray-800 mb-4">Ingresos vs Egresos Mensuales</h2>
    <div *ngIf="!isLoading && dashboardData; else noChartData">
      <apx-chart
        [series]="barSeries"
        [chart]="{ type: 'area', height: 350, stacked: true, toolbar: { show: false } }"
        [xaxis]="barXAxis"
        [colors]="barColors">
      </apx-chart>
    </div>
    <ng-template #noChartData>
      <div class="flex items-center justify-center h-80 text-gray-500">
        <div class="text-center">
          <div *ngIf="isLoading" class="animate-pulse mb-4">
            <div class="h-4 bg-gray-200 rounded w-48 mx-auto mb-2"></div>
            <div class="h-4 bg-gray-200 rounded w-32 mx-auto"></div>
          </div>
          <p>{{ isLoading ? 'Cargando gráfico...' : 'No hay datos para mostrar' }}</p>
        </div>
      </div>
    </ng-template>
  </div>

  <!-- Estado de Cuotas + Proyectos -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
    <div class="bg-white p-6 rounded-2xl shadow-md border border-gray-200">
      <h2 class="text-xl font-semibold text-gray-800 mb-4">Estado de Cuotas</h2>
      <div *ngIf="!isLoading && dashboardData; else noDoughnutData">
        <apx-chart
          [series]="doughnutSeries"
          [chart]="doughnutChart"
          [labels]="doughnutLabels"
          [colors]="doughnutColors"
          [legend]="{ position: 'bottom' }">
        </apx-chart>
      </div>
      <ng-template #noDoughnutData>
        <div class="flex items-center justify-center h-80 text-gray-500">
          <div class="text-center">
            <div *ngIf="isLoading" class="animate-pulse mb-4">
              <div class="w-24 h-24 bg-gray-200 rounded-full mx-auto mb-2"></div>
            </div>
            <p>{{ isLoading ? 'Cargando estado de cuotas...' : 'No hay datos de cuotas disponibles' }}</p>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="bg-white p-6 rounded-2xl shadow-md border border-gray-200">
      <h2 class="text-xl font-semibold text-gray-800 mb-4">Top Proyectos Rentables</h2>
      <ul class="divide-y divide-gray-200" *ngIf="topProjects.length > 0">
        <li *ngFor="let project of topProjects" class="py-2 flex justify-between">
          <span class="text-gray-700 font-medium">{{ project.name }}</span>
          <span class="text-green-700 font-bold">$ {{ project.profit | number:'1.0-0' }}</span>
        </li>
      </ul>
      <div *ngIf="!topProjects.length" class="text-center py-8 text-gray-500">
        <p class="text-sm">No hay proyectos rentables aún</p>
      </div>
    </div>
  </div>
    </ng-container>
    <!-- FIN SECCIÓN FULL -->

    <!-- ============================================ -->
    <!-- SECCIÓN BASIC: Datos Recientes             -->
    <!-- (Visible para BASIC y FULL)                -->
    <!-- ============================================ -->
  
  <!-- Secciones de datos recientes corporativas -->
  <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 mb-8">
    <!-- Últimos Participantes -->
    <div class="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow">
      <div class="bg-white px-6 py-4 border-b border-gray-200">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
              <fa-icon [icon]="['fas', 'users']" class="text-blue-600 text-sm"></fa-icon>
            </div>
            <div>
              <h3 class="font-semibold text-gray-900 text-base">Participantes</h3>
              <p class="text-gray-500 text-sm">Registros recientes</p>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <span class="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
              {{ (dashboardData?.recentData?.recentParticipants?.length || 0) }}
            </span>
            <a routerLink="/participants" target="_blank" 
               class="text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors">
              Ver todos →
            </a>
          </div>
        </div>
      </div>
      <div class="p-0">
        <div *ngIf="dashboardData?.recentData?.recentParticipants?.length; else noParticipants">
          <div *ngFor="let participant of dashboardData?.recentData?.recentParticipants; trackBy: trackByFn" 
               class="border-b border-gray-200 last:border-0 hover:bg-gray-50 transition-colors">
            <a [routerLink]="['/dashboard/participants/profile-participant', participant.id]" target="_blank" 
               class="block px-6 py-4 text-decoration-none">
              <div class="flex items-start justify-between">
                <div class="flex-1 min-w-0">
                  <p class="font-medium text-gray-900 truncate">{{ participant.title }}</p>
                  <p class="text-sm text-gray-600 truncate mt-1">{{ participant.subtitle }}</p>
                  <p class="text-xs text-gray-500 mt-1">{{ participant.description }}</p>
                </div>
                <div class="ml-4 flex-shrink-0">
                  <span class="text-xs text-gray-400">{{ participant.date | date:'MMM d' }}</span>
                  <div class="w-2 h-2 rounded-full mt-1 ml-auto" 
                       [ngClass]="{
                         'bg-green-400': participant.statusColor === 'green',
                         'bg-blue-400': participant.statusColor === 'blue',
                         'bg-gray-400': !participant.statusColor
                       }">
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <ng-template #noParticipants>
          <div class="text-center py-12">
            <div class="mx-auto w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-4">
              <fa-icon [icon]="['fas', 'users']" class="text-gray-400 text-lg"></fa-icon>
            </div>
            <p class="text-gray-500 text-sm font-medium">No hay participantes recientes</p>
            <p class="text-gray-400 text-xs">Los nuevos registros aparecerán aquí</p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Últimas Empresas -->
    <div class="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow">
      <div class="bg-white px-6 py-4 border-b border-gray-200">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center">
              <fa-icon [icon]="['fas', 'building']" class="text-purple-600 text-sm"></fa-icon>
            </div>
            <div>
              <h3 class="font-semibold text-gray-900 text-base">Empresas</h3>
              <p class="text-gray-500 text-sm">Registradas</p>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <span class="bg-purple-100 text-purple-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
              {{ (dashboardData?.recentData?.recentCompanies?.length || 0) }}
            </span>
            <a routerLink="/companies" target="_blank" 
               class="text-purple-600 hover:text-purple-800 text-sm font-medium transition-colors">
              Ver todas →
            </a>
          </div>
        </div>
      </div>
      <div class="p-0">
        <div *ngIf="dashboardData?.recentData?.recentCompanies?.length; else noCompanies">
          <div *ngFor="let company of dashboardData?.recentData?.recentCompanies; trackBy: trackByFn" 
               class="border-b border-gray-200 last:border-0 hover:bg-gray-50 transition-colors">
            <a [href]="'/companies/' + company.id" target="_blank" 
               class="block px-6 py-4 text-decoration-none">
              <div class="flex items-start justify-between">
                <div class="flex-1 min-w-0">
                  <p class="font-medium text-gray-900 truncate">{{ company.title }}</p>
                  <p class="text-sm text-gray-600 truncate mt-1">{{ company.subtitle }}</p>
                  <p class="text-xs text-gray-500 mt-1">{{ company.description }}</p>
                </div>
                <div class="ml-4 flex-shrink-0 text-right">
                  <span class="text-xs text-gray-400">{{ company.date | date:'MMM d' }}</span>
                </div>
              </div>
            </a>
          </div>
        </div>
        <ng-template #noCompanies>
          <div class="text-center py-12">
            <div class="mx-auto w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-4">
              <fa-icon [icon]="['fas', 'building']" class="text-gray-400 text-lg"></fa-icon>
            </div>
            <p class="text-gray-500 text-sm font-medium">No hay empresas recientes</p>
            <p class="text-gray-400 text-xs">Las nuevas empresas aparecerán aquí</p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Últimos Terceros -->
    <div class="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow">
      <div class="bg-white px-6 py-4 border-b border-gray-200">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center">
              <fa-icon [icon]="['fas', 'user-tie']" class="text-indigo-600 text-sm"></fa-icon>
            </div>
            <div>
              <h3 class="font-semibold text-gray-900 text-base">Terceros</h3>
              <p class="text-gray-500 text-sm">Registrados</p>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <span class="bg-indigo-100 text-indigo-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
              {{ (dashboardData?.recentData?.recentThirdParties?.length || 0) }}
            </span>
            <a routerLink="/third-parties" target="_blank" 
               class="text-indigo-600 hover:text-indigo-800 text-sm font-medium transition-colors">
              Ver todos →
            </a>
          </div>
        </div>
      </div>
      <div class="p-0">
        <div *ngIf="dashboardData?.recentData?.recentThirdParties?.length; else noThirdParties">
          <div *ngFor="let thirdParty of dashboardData?.recentData?.recentThirdParties; trackBy: trackByFn" 
               class="border-b border-gray-200 last:border-0 hover:bg-gray-50 transition-colors">
            <a [href]="'/third-parties/profile/' + thirdParty.id" target="_blank" 
               class="block px-6 py-4 text-decoration-none">
              <div class="flex items-start justify-between">
                <div class="flex-1 min-w-0">
                  <p class="font-medium text-gray-900 truncate">{{ thirdParty.title }}</p>
                  <p class="text-sm text-gray-600 truncate mt-1">{{ thirdParty.subtitle }}</p>
                  <p class="text-xs text-gray-500 mt-1">{{ thirdParty.description }}</p>
                </div>
                <div class="ml-4 flex-shrink-0 text-right">
                  <span class="text-xs text-gray-400">{{ thirdParty.date | date:'MMM d' }}</span>
                </div>
              </div>
            </a>
          </div>
        </div>
        <ng-template #noThirdParties>
          <div class="text-center py-12">
            <div class="mx-auto w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-4">
              <fa-icon [icon]="['fas', 'user-tie']" class="text-gray-400 text-lg"></fa-icon>
            </div>
            <p class="text-gray-500 text-sm font-medium">No hay terceros recientes</p>
            <p class="text-gray-400 text-xs">Los nuevos terceros aparecerán aquí</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <!-- Secciones financieras corporativas -->
  <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
    <!-- Órdenes de Trabajo Pendientes -->
    <div class="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow">
      <div class="bg-white px-6 py-4 border-b border-gray-200">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="w-8 h-8 bg-orange-100 rounded-lg flex items-center justify-center">
              <fa-icon [icon]="['fas', 'clipboard-list']" class="text-orange-600 text-sm"></fa-icon>
            </div>
            <div>
              <h3 class="font-semibold text-gray-900 text-base">Órdenes de Trabajo</h3>
              <p class="text-gray-500 text-sm">Pendientes</p>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <span class="bg-orange-100 text-orange-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
              {{ (dashboardData?.recentData?.pendingWorkOrders?.length || 0) }}
            </span>
            <a routerLink="/work-orders" target="_blank" 
               class="text-orange-600 hover:text-orange-800 text-sm font-medium transition-colors">
              Ver todas →
            </a>
          </div>
        </div>
      </div>
      <div class="p-0">
        <div *ngIf="dashboardData?.recentData?.pendingWorkOrders?.length; else noWorkOrders">
          <div *ngFor="let workOrder of dashboardData?.recentData?.pendingWorkOrders; trackBy: trackByFn" 
               class="border-b border-gray-200 last:border-0 hover:bg-gray-50 transition-colors">
            <a [href]="'/work-orders/' + workOrder.id" target="_blank" 
               class="block px-6 py-4 text-decoration-none">
              <div class="flex items-start justify-between">
                <div class="flex-1 min-w-0">
                  <p class="font-medium text-gray-900 truncate">{{ workOrder.title }}</p>
                  <p class="text-sm text-gray-600 truncate mt-1">{{ workOrder.subtitle }}</p>
                  <p class="text-xs text-gray-500 mt-1">{{ workOrder.description }}</p>
                </div>
                <div class="ml-4 flex-shrink-0 text-right">
                  <div class="bg-orange-50 text-orange-700 px-2 py-1 rounded text-xs font-medium mb-1">
                    $ {{ workOrder.amount | number:'1.0-0' }}
                  </div>
                  <span class="text-xs text-gray-400">{{ workOrder.date | date:'MMM d' }}</span>
                </div>
              </div>
            </a>
          </div>
        </div>
        <ng-template #noWorkOrders>
          <div class="text-center py-12">
            <div class="mx-auto w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-4">
              <fa-icon [icon]="['fas', 'clipboard-check']" class="text-gray-400 text-lg"></fa-icon>
            </div>
            <p class="text-gray-500 text-sm font-medium">No hay órdenes pendientes</p>
            <p class="text-gray-400 text-xs">Todas las órdenes están procesadas</p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Comprobantes de Egreso Recientes -->
    <div class="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow">
      <div class="bg-white px-6 py-4 border-b border-gray-200">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center">
              <fa-icon [icon]="['fas', 'money-bill-wave']" class="text-red-600 text-sm"></fa-icon>
            </div>
            <div>
              <h3 class="font-semibold text-gray-900 text-base">Egresos</h3>
              <p class="text-gray-500 text-sm">Recientes</p>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <span class="bg-red-100 text-red-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
              {{ (dashboardData?.recentData?.recentExpenseVouchers?.length || 0) }}
            </span>
            <a routerLink="/expense-receipts" target="_blank" 
               class="text-red-600 hover:text-red-800 text-sm font-medium transition-colors">
              Ver todos →
            </a>
          </div>
        </div>
      </div>
      <div class="p-0">
        <div *ngIf="dashboardData?.recentData?.recentExpenseVouchers?.length; else noExpenses">
          <div *ngFor="let expense of dashboardData?.recentData?.recentExpenseVouchers; trackBy: trackByFn" 
               class="border-b border-gray-200 last:border-0 hover:bg-gray-50 transition-colors">
            <a [href]="'/expense-receipts/' + expense.id" target="_blank" 
               class="block px-6 py-4 text-decoration-none">
              <div class="flex items-start justify-between">
                <div class="flex-1 min-w-0">
                  <p class="font-medium text-gray-900 truncate">{{ expense.title }}</p>
                  <p class="text-sm text-gray-600 truncate mt-1">{{ expense.subtitle }}</p>
                  <p class="text-xs text-gray-500 mt-1">{{ expense.description }}</p>
                </div>
                <div class="ml-4 flex-shrink-0 text-right">
                  <div class="bg-red-50 text-red-700 px-2 py-1 rounded text-xs font-medium mb-1">
                    $ {{ expense.amount | number:'1.0-0' }}
                  </div>
                  <span class="text-xs text-gray-400">{{ expense.date | date:'MMM d' }}</span>
                </div>
              </div>
            </a>
          </div>
        </div>
        <ng-template #noExpenses>
          <div class="text-center py-12">
            <div class="mx-auto w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-4">
              <fa-icon [icon]="['fas', 'money-bill-wave']" class="text-gray-400 text-lg"></fa-icon>
            </div>
            <p class="text-gray-500 text-sm font-medium">No hay egresos recientes</p>
            <p class="text-gray-400 text-xs">Los gastos aparecerán aquí</p>
          </div>
        </ng-template>
      </div>
    </div>

    <!-- Comprobantes de Ingreso Recientes -->
    <div class="bg-white rounded-xl border border-gray-200 overflow-hidden hover:shadow-lg transition-shadow">
      <div class="bg-white px-6 py-4 border-b border-gray-200">
        <div class="flex items-center justify-between">
          <div class="flex items-center space-x-3">
            <div class="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
              <fa-icon [icon]="['fas', 'wallet']" class="text-green-600 text-sm"></fa-icon>
            </div>
            <div>
              <h3 class="font-semibold text-gray-900 text-base">Ingresos</h3>
              <p class="text-gray-500 text-sm">Recientes</p>
            </div>
          </div>
          <div class="flex items-center space-x-2">
            <span class="bg-green-100 text-green-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
              {{ (dashboardData?.recentData?.recentIncomeReceipts?.length || 0) }}
            </span>
            <a routerLink="/income-receipts" target="_blank" 
               class="text-green-600 hover:text-green-800 text-sm font-medium transition-colors">
              Ver todos →
            </a>
          </div>
        </div>
      </div>
      <div class="p-0">
        <div *ngIf="dashboardData?.recentData?.recentIncomeReceipts?.length; else noIncomes">
          <div *ngFor="let income of dashboardData?.recentData?.recentIncomeReceipts; trackBy: trackByFn" 
               class="border-b border-gray-200 last:border-0 hover:bg-gray-50 transition-colors">
            <a [href]="'/income-receipts/' + income.id" target="_blank" 
               class="block px-6 py-4 text-decoration-none">
              <div class="flex items-start justify-between">
                <div class="flex-1 min-w-0">
                  <p class="font-medium text-gray-900 truncate">{{ income.title }}</p>
                  <p class="text-sm text-gray-600 truncate mt-1">{{ income.subtitle }}</p>
                  <p class="text-xs text-gray-500 mt-1">{{ income.description }}</p>
                </div>
                <div class="ml-4 flex-shrink-0 text-right">
                  <div class="bg-green-50 text-green-700 px-2 py-1 rounded text-xs font-medium mb-1">
                    $ {{ income.amount | number:'1.0-0' }}
                  </div>
                  <span class="text-xs text-gray-400">{{ income.date | date:'MMM d' }}</span>
                </div>
              </div>
            </a>
          </div>
        </div>
        <ng-template #noIncomes>
          <div class="text-center py-12">
            <div class="mx-auto w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-4">
              <fa-icon [icon]="['fas', 'wallet']" class="text-gray-400 text-lg"></fa-icon>
            </div>
            <p class="text-gray-500 text-sm font-medium">No hay ingresos recientes</p>
            <p class="text-gray-400 text-xs">Los pagos aparecerán aquí</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
  
  </ng-container>
  <!-- FIN SECCIÓN BASIC -->
  
</div>
